import React from 'react';
import ReactDOM from 'react-dom/client';
// Cloudscape's global stylesheet is a REQUIRED side-effect import — components render unstyled
// without it. It must come before our own layers so `styles/global.css` still wins on `body`.
import '@cloudscape-design/global-styles/index.css';
import { applyDensity, applyMode, Density, Mode } from '@cloudscape-design/global-styles';
// GENERATED at build time from src/theme/portalTheme.ts (see scripts/build-theme.mjs). Doing the
// theming here rather than through the runtime `applyTheme()` keeps the colour engine out of the
// browser bundle — 0.7 kB of CSS instead of 94 kB of JS.
import './styles/generated-theme.css';
import { App } from './App';
import './styles/global.css';
import './styles/cloudscape-shell.css';
import './components/shared/shared.css';

// Both themes are deliberate; light is the default and dark is an explicit operator choice. Never
// auto-dark off the OS preference — a console that changes appearance on its own is a false signal.
applyMode(Mode.Light);
applyDensity(Density.Comfortable);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
